import { OverdueService } from './services/OverdueService';
import type { Init } from './types';
import { managerHelpers } from '../../helpers';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import type { WidgetLifecycle } from '../WidgetLifecycle';
import { WithApi } from '../WithApi';

export type OverdueSummaryData = MergedDataReturnType<[OverdueService]>;

export type OverdueSummaryHandlers = MergedHandlersReturnType<[OverdueService]>;

type TApi = ReturnType<OverdueService['api']>;

export class OverdueSummaryManager extends WithApi<TApi> {
  public overdueSummaryInit = ({ queries, t }: Init) => {
    const [balanceQuery, billingAccountQuery] = queries;

    const pending = balanceQuery.isPending || billingAccountQuery.isPending;
    const error = balanceQuery.error || billingAccountQuery.error;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
        lifecycle: {} as WidgetLifecycle,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
        lifecycle: {} as WidgetLifecycle,
      } as const;
    }

    const overdue = new OverdueService(balanceQuery.data, billingAccountQuery.data, t);

    this.initApi({
      ...overdue.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...overdue.data(),
        error,
      },
      handlers: {
        ...overdue.handlers(),
        retry: () => {
          managerHelpers.retryQueries(queries);
        },
      },
    } as const;
  };
}
